export const executionEnvironmentSections = ['runners', 'models'] as const;

export type ExecutionEnvironmentSection = (typeof executionEnvironmentSections)[number];

export const parseExecutionEnvironmentSection = (
  value: string | null | undefined,
  fallback: ExecutionEnvironmentSection = 'runners',
): ExecutionEnvironmentSection =>
  executionEnvironmentSections.includes(value as ExecutionEnvironmentSection)
    ? (value as ExecutionEnvironmentSection)
    : fallback;

export const executionEnvironmentModalEventName = 'openExecutionEnvironmentModal';

/**
 * 계정 범위 `내 실행 환경` 모달을 연다.
 *
 * 러너·개인 모델은 프로젝트가 아니라 사용자 계정 자산이므로 프로젝트 화면으로 이동시키지 않고
 * 어느 화면에서든 전역 모달로 띄운다. 이벤트로 두는 이유는 호출처(홈 CTA, 실행 구성 카드 등)가
 * 무거운 러너 관리 컴포넌트를 import하지 않게 하기 위해서다.
 */
export const openExecutionEnvironmentModal = (section: ExecutionEnvironmentSection = 'runners') => {
  window.dispatchEvent(new CustomEvent(executionEnvironmentModalEventName, { detail: { section } }));
};
